import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { translations } from "../i18n/translations";
import { images } from "../data/images";

const slides = [
  images.realHouseNight,
  images.poolArea,
  images.realLivingRoom,
  images.heroAerial1
];

export default function Hero() {
  const { t } = useLanguage();
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setIdx((i) => (i + 1) % slides.length), 6500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="inicio" className="relative h-screen w-full overflow-hidden bg-[#1a1a18]">
      {slides.map((src, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-[2000ms] ease-in-out ${
            i === idx ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={src}
            alt="NACUII residence"
            className="w-full h-full object-cover scale-[1.05] animate-[heroZoom_12s_ease-out_infinite_alternate]"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/55" />
        </div>
      ))}

      <div className="relative z-10 h-full w-full flex flex-col justify-end pb-24 lg:pb-32">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-12 w-full">
          <div className="max-w-3xl">
            <p
              className="text-white/90 text-[11px] lg:text-[12px] tracking-[0.5em] uppercase mb-6"
              style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
            >
              {t(translations.hero.eyebrow)}
            </p>
            <h1
              className="text-white text-[40px] sm:text-[56px] lg:text-[78px] leading-[1.05] mb-8"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, letterSpacing: "0.01em" }}
            >
              {t(translations.hero.title1)}
              <br />
              <em className="italic font-light">{t(translations.hero.title2)}</em>
            </h1>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 mt-10">
              <a
                href="#residencia"
                className="inline-flex items-center justify-center px-9 py-4 text-[11px] tracking-[0.3em] uppercase border border-white text-white hover:bg-white hover:text-[#2A2A28] transition-colors duration-300"
                style={{ fontFamily: "'Jost', sans-serif" }}
              >
                {t(translations.hero.discover)}
              </a>
              <a
                href="#contacto"
                className="inline-flex items-center justify-center px-9 py-4 text-[11px] tracking-[0.3em] uppercase bg-white/95 text-[#2A2A28] hover:bg-[#9C8456] hover:text-white transition-colors duration-300"
                style={{ fontFamily: "'Jost', sans-serif" }}
              >
                {t(translations.hero.bookVisit)}
              </a>
            </div>
          </div>
        </div>

        <div className="absolute bottom-10 right-6 lg:right-12 flex gap-3 z-20">
          {slides.map((_, i) => (
            <button
              key={i}
              aria-label={`Slide ${i + 1}`}
              onClick={() => setIdx(i)}
              className={`h-[2px] transition-all duration-500 ${
                i === idx ? "w-12 bg-white" : "w-6 bg-white/40"
              }`}
            />
          ))}
        </div>

        <a
          href="#residencia"
          className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/80 hover:text-white animate-bounce z-20"
          aria-label="Scroll"
        >
          <ChevronDown className="w-6 h-6" />
        </a>
      </div>
    </section>
  );
}
